import { Table } from '@chakra-ui/react';
import { memo } from 'react';

import { productCatalog, ProductDetails } from 'helpers/fakeData';

interface Inventory extends ProductDetails {
  stock: number;
}

const inventory: Inventory[] = productCatalog.map((product, index) => ({
  ...product,
  stock: 10 + index,
}));

const InventoryTable = () => {
  return (
    <Table.Root borderRadius="md" height="fit-content" cursor="pointer">
      <Table.Header>
        <Table.Row bg="sidebar.background">
          <Table.ColumnHeader>Name</Table.ColumnHeader>
          <Table.ColumnHeader>Model</Table.ColumnHeader>
          <Table.ColumnHeader>Stock</Table.ColumnHeader>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {inventory.map((item) => (
          <Table.Row key={item.id} _hover={{ bg: 'button.secondary.hover' }}>
            <Table.Cell>{item.name}</Table.Cell>
            <Table.Cell>{item.model}</Table.Cell>
            <Table.Cell>{item.stock}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table.Root>
  );
};

export default memo(InventoryTable);
